import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ModalState {
  isOpen: boolean;
  imageSrc: string |ArrayBuffer;
  imageAlt: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImgModalService {
  private modalStateSubject = new BehaviorSubject<ModalState>({
    isOpen: false,
    imageSrc: '',
    imageAlt: ''
  });

  modalState$ = this.modalStateSubject.asObservable();

  openModal(imageSrc: string| ArrayBuffer, imageAlt: string = '') {
    this.modalStateSubject.next({ isOpen: true, imageSrc, imageAlt });
  }

  closeModal() {
    this.modalStateSubject.next({ isOpen: false, imageSrc: '', imageAlt: '' });
  }
}